export default "__VITE_ASSET__BoZspfPL__"